// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file gd_objects.proto (package gd.objects.v1, syntax proto3)
/* eslint-disable */

// Canonical encodings of Grovedock's content-addressed objects. Ids are
// BLAKE3-256(tag || canonical bytes) with tag 1 = blob (raw file bytes, not a message),
// 2 = tree, 3 = changeset. Stored and wire payloads are `tag || zstd(bytes)`; a large file
// is stored under its blob id as `0x03 || Manifest`. `ChangesetInfo.encoded` carries a
// canonical Changeset.

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gd_objects.proto.
 */
export const file_gd_objects: GenFile = /*@__PURE__*/
  fileDesc("ChBnZF9vYmplY3RzLnByb3RvEg1nZC5vYmplY3RzLnYxIkgKCVRyZWVFbnRyeRIMCgRuYW1lGAEgASgJEiEKBG1vZGUYAiABKA4yEy5nZC5vYmplY3RzLnYxLk1vZGUSCgoCaWQYAyABKAwiMQoEVHJlZRIpCgdlbnRyaWVzGAEgAygLMhguZ2Qub2JqZWN0cy52MS5UcmVlRW50cnkiSwoKRmlsZUNoYW5nZRIMCgRwYXRoGAEgASgJEgwKBGJsb2IYAiABKAwSIQoEbW9kZRgDIAEoDjITLmdkLm9iamVjdHMudjEuTW9kZSKmAQoJQ2hhbmdlc2V0Eg8KB3BhcmVudHMYASADKAwSKgoHY2hhbmdlcxgCIAMoCzIZLmdkLm9iamVjdHMudjEuRmlsZUNoYW5nZRIOCgZhdXRob3IYAyABKAkSDwoHbWVzc2FnZRgEIAEoCRIUCgx0aW1lc3RhbXBfbXMYBSABKAMSJQoDZ2l0GAYgASgLMhguZ2Qub2JqZWN0cy52MS5HaXRPcmlnaW4iogIKCUdpdE9yaWdpbhIOCgZhdXRob3IYASABKAkSEQoJY29tbWl0dGVyGAIgASgJEhAKCGVuY29kaW5nGAMgASgJEg8KB21lc3NhZ2UYBCABKAwSGwoTc2lnbmF0dXJlX2FsZ29yaXRobRgFIAEoCRIRCglzaWduYXR1cmUYBiABKAwSKAoIZ2l0bGlua3MYByADKAsyFi5nZC5vYmplY3RzLnYxLkdpdGxpbmsSDgoGY29tbWl0GAggASgJEiUKBW1vZGVzGAkgAygLMhYuZ2Qub2JqZWN0cy52MS5HaXRNb2RlEhQKDGF1dGhvcl9ieXRlcxgKIAEoDBIXCg9jb21taXR0ZXJfYnl0ZXMYCyABKAwSDwoHaGVhZGVycxgMIAEoDCIlCgdHaXRNb2RlEgwKBHBhdGgYASABKAkSDAoEbW9kZRgCIAEoCSInCgdHaXRsaW5rEgwKBHBhdGgYASABKAkSDgoGY29tbWl0GAIgASgJIiMKCENodW5rUmVmEgoKAmlkGAEgASgMEgsKA2xlbhgCIAEoBCJBCghNYW5pZmVzdBIMCgRzaXplGAEgASgEEicKBmNodW5rcxgCIAMoCzIXLmdkLm9iamVjdHMudjEuQ2h1bmtSZWYqMAoETW9kZRIICgRGSUxFEAASCAoERVhFQxABEgsKB1NZTUxJTksQAhIHCgNESVIQA2IGcHJvdG8z");

/**
 * Directory entry. A tree's entries are sorted by name (bytewise) and names are unique.
 *
 * @generated from message gd.objects.v1.TreeEntry
 */
export type TreeEntry = Message<"gd.objects.v1.TreeEntry"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: gd.objects.v1.Mode mode = 2;
   */
  mode: Mode;

  /**
   * @generated from field: bytes id = 3;
   */
  id: Uint8Array;
};

/**
 * Describes the message gd.objects.v1.TreeEntry.
 * Use `create(TreeEntrySchema)` to create a new message.
 */
export const TreeEntrySchema: GenMessage<TreeEntry> = /*@__PURE__*/
  messageDesc(file_gd_objects, 0);

/**
 * @generated from message gd.objects.v1.Tree
 */
export type Tree = Message<"gd.objects.v1.Tree"> & {
  /**
   * @generated from field: repeated gd.objects.v1.TreeEntry entries = 1;
   */
  entries: TreeEntry[];
};

/**
 * Describes the message gd.objects.v1.Tree.
 * Use `create(TreeSchema)` to create a new message.
 */
export const TreeSchema: GenMessage<Tree> = /*@__PURE__*/
  messageDesc(file_gd_objects, 1);

/**
 * Change relative to the changeset's first parent. Empty `blob` = delete.
 *
 * @generated from message gd.objects.v1.FileChange
 */
export type FileChange = Message<"gd.objects.v1.FileChange"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: bytes blob = 2;
   */
  blob: Uint8Array;

  /**
   * @generated from field: gd.objects.v1.Mode mode = 3;
   */
  mode: Mode;
};

/**
 * Describes the message gd.objects.v1.FileChange.
 * Use `create(FileChangeSchema)` to create a new message.
 */
export const FileChangeSchema: GenMessage<FileChange> = /*@__PURE__*/
  messageDesc(file_gd_objects, 2);

/**
 * @generated from message gd.objects.v1.Changeset
 */
export type Changeset = Message<"gd.objects.v1.Changeset"> & {
  /**
   * @generated from field: repeated bytes parents = 1;
   */
  parents: Uint8Array[];

  /**
   * @generated from field: repeated gd.objects.v1.FileChange changes = 2;
   */
  changes: FileChange[];

  /**
   * @generated from field: string author = 3;
   */
  author: string;

  /**
   * @generated from field: string message = 4;
   */
  message: string;

  /**
   * @generated from field: int64 timestamp_ms = 5;
   */
  timestampMs: bigint;

  /**
   * For a changeset that came from git: what git needs to make the very same commit again.
   * Absent for changes made with gd (so their ids don't change); not kept when a land rebases.
   *
   * @generated from field: gd.objects.v1.GitOrigin git = 6;
   */
  git?: GitOrigin | undefined;
};

/**
 * Describes the message gd.objects.v1.Changeset.
 * Use `create(ChangesetSchema)` to create a new message.
 */
export const ChangesetSchema: GenMessage<Changeset> = /*@__PURE__*/
  messageDesc(file_gd_objects, 3);

/**
 * A git commit's identity beyond what a changeset holds, kept so that the git view of a
 * history (git over HTTPS, mirrors, exports) reproduces the original commit ids.
 *
 * @generated from message gd.objects.v1.GitOrigin
 */
export type GitOrigin = Message<"gd.objects.v1.GitOrigin"> & {
  /**
   * As git wrote them: "Name <email> SECONDS +ZZZZ".
   *
   * @generated from field: string author = 1;
   */
  author: string;

  /**
   * @generated from field: string committer = 2;
   */
  committer: string;

  /**
   * The message's encoding when it isn't UTF-8 (then `message` holds its bytes).
   *
   * @generated from field: string encoding = 3;
   */
  encoding: string;

  /**
   * @generated from field: bytes message = 4;
   */
  message: Uint8Array;

  /**
   * A signed commit's signature, verbatim, and its hash algorithm ("sha1").
   *
   * @generated from field: string signature_algorithm = 5;
   */
  signatureAlgorithm: string;

  /**
   * @generated from field: bytes signature = 6;
   */
  signature: Uint8Array;

  /**
   * Submodule entries (gd keeps no submodules; git's trees do).
   *
   * @generated from field: repeated gd.objects.v1.Gitlink gitlinks = 7;
   */
  gitlinks: Gitlink[];

  /**
   * The commit id this must reproduce: checked when the git view is written, never trusted.
   *
   * @generated from field: string commit = 8;
   */
  commit: string;

  /**
   * Entries the commit's tree spells with a mode git no longer writes (100664 from git's first
   * months, a zero-padded 040000): the path and the mode as written, so the same tree, and the
   * same commit id, come back. Empty for nearly every commit.
   *
   * @generated from field: repeated gd.objects.v1.GitMode modes = 9;
   */
  modes: GitMode[];

  /**
   * The author and committer lines' bytes when they aren't UTF-8 (Latin-1 names in old
   * commits); `author` and `committer` then hold them made readable.
   *
   * @generated from field: bytes author_bytes = 10;
   */
  authorBytes: Uint8Array;

  /**
   * @generated from field: bytes committer_bytes = 11;
   */
  committerBytes: Uint8Array;

  /**
   * The commit's header lines after `committer`, exactly as written, when it has any that a
   * git import can't carry (`mergetag` from merging a signed tag, `change-id`): written back
   * verbatim. Empty for nearly every commit.
   *
   * @generated from field: bytes headers = 12;
   */
  headers: Uint8Array;
};

/**
 * Describes the message gd.objects.v1.GitOrigin.
 * Use `create(GitOriginSchema)` to create a new message.
 */
export const GitOriginSchema: GenMessage<GitOrigin> = /*@__PURE__*/
  messageDesc(file_gd_objects, 4);

/**
 * @generated from message gd.objects.v1.GitMode
 */
export type GitMode = Message<"gd.objects.v1.GitMode"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: string mode = 2;
   */
  mode: string;
};

/**
 * Describes the message gd.objects.v1.GitMode.
 * Use `create(GitModeSchema)` to create a new message.
 */
export const GitModeSchema: GenMessage<GitMode> = /*@__PURE__*/
  messageDesc(file_gd_objects, 5);

/**
 * @generated from message gd.objects.v1.Gitlink
 */
export type Gitlink = Message<"gd.objects.v1.Gitlink"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: string commit = 2;
   */
  commit: string;
};

/**
 * Describes the message gd.objects.v1.Gitlink.
 * Use `create(GitlinkSchema)` to create a new message.
 */
export const GitlinkSchema: GenMessage<Gitlink> = /*@__PURE__*/
  messageDesc(file_gd_objects, 6);

/**
 * @generated from message gd.objects.v1.ChunkRef
 */
export type ChunkRef = Message<"gd.objects.v1.ChunkRef"> & {
  /**
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;

  /**
   * @generated from field: uint64 len = 2;
   */
  len: bigint;
};

/**
 * Describes the message gd.objects.v1.ChunkRef.
 * Use `create(ChunkRefSchema)` to create a new message.
 */
export const ChunkRefSchema: GenMessage<ChunkRef> = /*@__PURE__*/
  messageDesc(file_gd_objects, 7);

/**
 * Large file: content is the concatenation of the chunks (each a blob object).
 *
 * @generated from message gd.objects.v1.Manifest
 */
export type Manifest = Message<"gd.objects.v1.Manifest"> & {
  /**
   * @generated from field: uint64 size = 1;
   */
  size: bigint;

  /**
   * @generated from field: repeated gd.objects.v1.ChunkRef chunks = 2;
   */
  chunks: ChunkRef[];
};

/**
 * Describes the message gd.objects.v1.Manifest.
 * Use `create(ManifestSchema)` to create a new message.
 */
export const ManifestSchema: GenMessage<Manifest> = /*@__PURE__*/
  messageDesc(file_gd_objects, 8);

/**
 * @generated from enum gd.objects.v1.Mode
 */
export enum Mode {
  /**
   * @generated from enum value: FILE = 0;
   */
  FILE = 0,

  /**
   * @generated from enum value: EXEC = 1;
   */
  EXEC = 1,

  /**
   * @generated from enum value: SYMLINK = 2;
   */
  SYMLINK = 2,

  /**
   * @generated from enum value: DIR = 3;
   */
  DIR = 3,
}

/**
 * Describes the enum gd.objects.v1.Mode.
 */
export const ModeSchema: GenEnum<Mode> = /*@__PURE__*/
  enumDesc(file_gd_objects, 0);

